<template>
  <b-table
    show-empty
    head-variant="dark"
    empty-text="No Claims available."
    stacked="md"
    bordered
    striped
    small
    sticky-header="200px"
    :items="claimsummary"
    :fields="fieldsClaim"
    style="font-size: 12px"
  >
    <!-- <template v-slot:thead-top="">
        <b-tr>
            <b-th colspan="2"><span class="sr-only">SL and District Name</span></b-th>
            <b-th variant="secondary" colspan="5">Pending Claims</b-th>
        </b-tr>
        </template> -->

    <template v-slot:cell(SL)="row">
      {{ row.index + 1 }}
    </template>

    <template v-slot:cell(Accounts)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Accounts')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Accounts }}</b-button
      >
    </template>

    <template v-slot:cell(Auditor)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Auditor')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Auditor }}</b-button
      >
    </template>
    
    <!-- new Dgm start  -->
    <template v-slot:cell(DGM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'DGM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.DGM }}</b-button
      >
    </template>
    <!-- new Dgm end -->

    <template v-slot:cell(GM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'GM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.GM }}</b-button
      >
    </template>

    <template v-slot:cell(MD)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'MD')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.MD }}</b-button
      >
    </template>

    <template v-slot:cell(ToBePaid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'ToBePaid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.ToBePaid }}</b-button
      >
    </template>

    <template v-slot:cell(Paid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Paid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Paid }}</b-button
      >
    </template>

    <template v-slot:cell(Rejected)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Rejected')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Rejected }}</b-button
      >
    </template>
    <template v-slot:cell(Applicant)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Applicant')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Applicant }}</b-button
      >
    </template>
  </b-table>
</template>
<script>
import apis from "@/apis";
export default {
  mounted() {
    this.getClaimSummary('1');
    this.$root.$on('component1', (loanType) => {
            // your code goes here
            this.getClaimSummary(loanType.temploanType);
        })
  },
  methods: {
    getClaimSummary(loanType) {
      let promise = apis.ReadClaimDashBoard(loanType);

      promise
        .then((response) => {
          if (response.status == 401) {
            this.$store.dispatch("logout");
            this.$router.replace("/");
            return;
          }
          if (response.status == 200) {
            this.claimsummary = response.body;
            if (this.RoleID == 4) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].Accounts;
            this.PendingLabel = "Pending MD Approval";
            }
            // new Dgm start
            else if (this.RoleID == 5) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].DGM;
            this.PendingLabel = "Pending DGM Approval";
            }
            // new Dgm end

            else if (this.RoleID == 5) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].GM;
            this.PendingLabel = "Pending GM Approval";
            }else if (this.RoleID == 3) {
              let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
              this.PendingCountLOI = ttl[0].MD;
              this.PendingLabel = "Pending MD Approval";
            }
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.$emit("ttl", ttl[0].Accounts, ttl[0].DGM,ttl[0].GM, ttl[0].MD);
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
        var promise1;
      if (this.RoleID !== 3 && this.RoleID != 4 && this.RoleID != 5) {
        //promise1 = apis.getApplicationSummary(this.selectedDistrict);
      } else if (this.RoleID == 3 || this.RoleID == 4 || this.RoleID == 5) {
        //promise1 = apis.getApplicationSummaryMD(this.loanType);
      } else {
        return;
      }
    },
    viewClaims(item, sts) {
      this.$store.dispatch("setDistrict", item.DistrictID);
      //this.$store.dispatch("setAppStatus", sts);
      this.$store.dispatch("setStatusOwner", sts);
      this.$store.dispatch("setLoanType", 1);
      this.$router.push("/approveclaims");
    }
  },
  data() {
    return {
      claimsummary: [],
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      id:1,
      fieldsClaim: [
        { key: "SL", label: "SL" },
        { key: "DistrictName", label: "District Name" },
        { key: "Accounts", label: "Accounts" },
        { key: "Auditor", label: "Auditor" },
        
        // new Dgm start 
        { key: "DGM", label: "DGM" },
        // new Dgm end

        { key: "GM", label: "GM" },
        { key: "MD", label: "MD" },
        { key: "ToBePaid", label: "To Be Paid" },
        { key: "Paid", label: "Paid" },
        { key: "Rejected", label: "Rejected" },
        { key: "Applicant", label: "Applicant" },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/ClaimsTable.vue